import {useEffect } from "react";
import {useDispatch,useSelector  } from "react-redux";
import Header from "../components/Header";
import VideoDetection from "../components/VideoDetection";
import DetectionResult from "../components/DetectionResult";
import LoadingOverlay from "../ui/LoadingOverlay";
import MoonLoader from "react-spinners/MoonLoader";
import {setDetectionImage,setInferenceTime,setUploadedImage,setIsDetecting} from "../features/detectSlice";


function LiveDetection() {
  const dispatch = useDispatch();
  const { isLoading, message } = useSelector((state) => state.model);
  
  useEffect(() => {
    dispatch(setUploadedImage(null));
    dispatch(setDetectionImage(null));
    dispatch(setInferenceTime(0));
    dispatch(setIsDetecting(false));
  }, [dispatch]); //setDetectionImage,setInferenceTime,setUploadedImage,setIsDetecting
  return (
    <>
      <Header />
      <LoadingOverlay isVisible={isLoading} message={message}>
        <MoonLoader color="#00BFFF" size={50} />
      </LoadingOverlay>
      <div className="pageContent">
        <VideoDetection />
        <DetectionResult />
      </div>
    </>
  );
}

export default LiveDetection;